module.exports = __webpack_public_path__ + "img/131.be3d06f1.jpg";